<template>
  <adminTable
    ref="adminTableRef"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:form-inline-items>
      <el-form-item>
        <el-input v-model="searchForm.title" placeholder="搜索标题" clearable />
      </el-form-item>
    </template>
    <template v-slot:query-button-right>
      <el-button
        type="primary"
        icon="CirclePlus"
        @click="editItem('add', {})"
        v-permission
        >添加</el-button
      >
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="title" label="标题" width="150" />
      <el-table-column prop="class_name" label="分类" width="160" />
      <el-table-column prop="status" label="显示状态" width="140" >
        <template #default="scope">
          <QuickStatus
            v-model="scope.row.status"
            :id="scope.row.id"
            :options="showStatusEnums"
            url="GroupBuy/updateStatus"
            mode="switch"
          />
        </template>
      </el-table-column>
      <el-table-column prop="is_recommend" label="是否推荐" width="140" >
        <template #default="scope">
          <QuickStatus
            v-model="scope.row.is_recommend"
            :id="scope.row.id"
            :options="booleanEnums"
            url="GroupBuy/updateStatus"
            field="is_recommend"
            mode="switch"
          />
        </template>
      </el-table-column>
      <el-table-column prop="good_id" label="商品ID" width="100" />
      <el-table-column prop="good_name" label="商品名称" width="200" />
      <el-table-column prop="good_img" label="商品图片" width="200">
        <template #default="scope">
          {{ scope.row.good_img ? "" : "--" }}
          <el-image
            v-if="scope.row.good_img"
            class="previewImg"
            :preview-teleported="true"
            :src="proxy.IMG_BASE_URL + scope.row.good_img"
            :zoom-rate="1.2"
            :max-scale="7"
            :min-scale="0.2"
            :preview-src-list="[proxy.IMG_BASE_URL + scope.row.good_img]"
            show-progress
            :initial-index="0"
            fit="cover"
          />
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="160" />
      <el-table-column prop="price" label="拼团价格" width="160" />
      <el-table-column prop="people" label="拼团人数" width="160" />
      <!-- <el-table-column prop="process_time" label="进度时间" width="160" /> -->
      <el-table-column prop="people_add" label="每小时增加人数" width="160" />
      <!-- <el-table-column prop="process_update_time" label="进度更新时间" width="160" /> -->
      <el-table-column prop="fail_money" label="拼团失败返现" width="160" />
      <el-table-column prop="fail_points" label="拼团失败返积分" width="160" />
      <el-table-column prop="limit" label="限购次数" width="160" />
      <el-table-column prop="level" label="会员等级" width="160" />
      <el-table-column prop="item_money" label="需要投资金额" width="160" />
      <el-table-column prop="activity_val" label="活跃度" width="120" />
      <el-table-column prop="next_time" label="开奖时间" width="160" />
      <el-table-column prop="cycle" label="开奖周期（天）" width="160" />
      <el-table-column prop="desc" label="福利说明" width="200" />
      <el-table-column prop="create_at" label="添加时间" width="130" />
      <el-table-column prop="update_at" label="更新时间" width="130" />
      <el-table-column
        label="操作"
        width="200"
        fixed="right"
        v-if="currentUser.role == 0"
      >
        <template #default="scope">
          <el-button
            type="primary"
            icon="Edit"
            v-permission
            @click="editItem('edit', scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            icon="Delete"
            v-permission
            @click="deleteAction(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </template>
    <el-dialog v-model="dialogFlag" title="编辑/新增" width="1100">
      <editPop :key="editRow" ref="editFormRef" :item="editRow" />

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="submitForm"> 保存 </el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { booleanEnums, getLabelByVal, showStatusEnums } from "@/config/enums";
import EditPop from "./components/pintuanList/editPop.vue";
import { ElMessage, ElMessageBox } from "element-plus";

const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const searchForm = ref({
  title: "",
});
const dialogFlag = ref(false);
const editRow = ref({});
const editFormRef = ref(null);
const adminTableRef = ref(null);
const formType = ref("add");

onMounted(() => {
  getList();
});

const editItem = (type, row = {}) => {
  formType.value = type;
  editRow.value = row;
  dialogFlag.value = true;
};

const submitForm = async () => {
  const url = formType.value == "add" ? "GroupBuy/addGroupBuy" : "GroupBuy/updateGroupBuy";
  const data = editFormRef.value.form;
  if (formType.value == "add") {
    data.id = null;
  }
  const res = await proxy.$http({
    method: "post",
    url: url,
    data: {
      title: data.title,
      class_id: data.class_id,
      is_recommend: data.is_recommend,
      sort: data.sort,
      price: data.price,
      people: data.people,
      fail_points: data.fail_points,
      people_add: data.people_add,
      // process_update_time: data.process_update_time,
      fail_money: data.fail_money,
      limit: data.limit,
      level: data.level,
      item_money: data.item_money,
      status: data.status,
      next_time: data.next_time,
      cycle: data.cycle,
      desc: data.desc,
      good_id: data.good_id,
      good_img: data.good_img,
      activity_val: data.activity_val,
      id: data.id,
    },
  });

  if (res.code == 0) {
    dialogFlag.value = false;
    getList();
    ElMessage({
      type: "success",
      message: res.msg,
    });
  } else {
    dialogFlag.value = false;
    ElMessage({
      type: "error",
      message: res.msg,
    });
  }
};

const deleteAction = (row) => {
  ElMessageBox.confirm("是否删除?", "Warning", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      const res = await proxy.$http({
        method: "get",
        url: "GroupBuy/deleteGroupBuy?id=" + row.id,
      });
      if (res.code == 0) {
        getList();
      }
      ElMessage({
        type: "success",
        message: res.msg,
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消删除",
      });
    });
};

const { proxy } = getCurrentInstance();

const tableData = ref([]);
const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);

const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/GroupBuy/getGroupBuyLists",
    params: {
      page: page.value,
      limit: limit.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};
</script>

<style lang="less" scoped></style>
